import React, { useMemo, memo } from 'react';
import { getNotesArray } from './getNotesArray';

const PianoRollKeyboard = memo(({ lowNote, highNote, keyHeight, keyWidth }) => {
   const notes = useMemo(() => getNotesArray(lowNote, highNote), [
      lowNote,
      highNote,
   ]);
   const keyboardHeight = (highNote - lowNote + 1) * keyHeight;
   return (
      <svg
         className="piano-roll-keyboard"
         width={keyWidth}
         height={keyboardHeight}
      >
         {notes.map((note, i) => {
            const isSharp = note.match('#');
            const needsBorder = note.match(/(b|e)\d/);
            const needsLabel = note.match(/c\d/);

            if (isSharp || needsBorder || needsLabel) {
               return (
                  <g key={note}>
                     {isSharp && (
                        <rect
                           className="piano-roll-key"
                           height={keyHeight}
                           width={keyWidth}
                           y={i * keyHeight}
                           data-note-name={note}
                        />
                     )}
                     {needsBorder && (
                        <line
                           className="piano-roll-key-gap"
                           x1={0}
                           x2={keyWidth}
                           y1={i * keyHeight}
                           y2={i * keyHeight}
                        />
                     )}
                     {needsLabel && (
                        <text
                           className="piano-roll-key-label"
                           x={keyWidth / 2}
                           y={(i + 0.8) * keyHeight}
                        >
                           {note.toUpperCase()}
                        </text>
                     )}
                  </g>
               );
            }
            return null;
         })}
      </svg>
   );
});

export { PianoRollKeyboard };
